import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MdOutlineDriveFolderUpload } from 'react-icons/md';
import { AiOutlineFolderAdd } from 'react-icons/ai';
import { CiStickyNote } from 'react-icons/ci';
import { RiArrowRightSLine, RiArrowLeftSLine } from 'react-icons/ri';
import { TbFileUpload } from 'react-icons/tb';
import { useHistory } from 'react-router-dom';
import { ActionButton, Folder, InputModal, MovingFileView, UploadMenu } from '../../components';
import s from './style.css';
import gs from '../../global.css';
import { vault, auth } from '../../actions';
import { createFileSections, isCloseToBottom } from '../../utils';
import FileView from '../FileView';
import ContextMenu from '../../components/ContextMenu';
let loadingMore = false;
const VaultScreen = (props) => {
    const history = useHistory();
    const handleScroll = () => {
        if (isCloseToBottom() && !loadingMore && props.url) {
            loadingMore = true;
            if (props.isSearching)
                props.searchItems(props.searchUrl, false);
            else
                props.fetchFiles({
                    currentUrl: props.url,
                    folderId: props.currentFolder.id,
                    firstFetch: false,
                    refresh: false,
                    callback: () => (loadingMore = false),
                });
        }
    };
    useEffect(() => {
        if (!props.user || !props.isAuthenticated) {
            props.logout(() => history.push('/portal-login'));
            return;
        }
        const parts = window.location.pathname
            ?.split('/')
            .filter((item) => item !== '')
            .slice(2);
        if (!props.fetched && parts.length === 0) {
            props.fetchLatestFiles(() => props.fetchFiles({ currentUrl: props.url, folderId: 'home', firstFetch: false, refresh: true }));
        }
        props.goToFolder(parts);
        props.refreshUser();
    }, []);
    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            if (action === 'POP') {
                if (props.fileViewVisible)
                    props.hideFileView();
                else
                    props.closeFolder();
            }
        });
        return () => {
            unlisten();
        };
    }, [props.fileViewVisible]);
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [props.url]);
    const [highlighted, setHighlighted] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [folderName, setFolderName] = useState('');
    const SectionTitle = ({ section }) => {
        return (React.createElement("div", { className: s.sectionTitleContainer },
            React.createElement("p", { className: s.sectionTitle }, section.title),
            section.title !== 'Recent' && (React.createElement("p", { className: s.sectionCount },
                section.data.length,
                " item",
                section.data.length > 1 ? 's' : ''))));
    };
    const handleUploadFiles = async (e) => {
        e.preventDefault();
        const folderId = props.currentFolder.id !== 'search' ? props.currentFolder.id : 'home';
        props.uploadFiles(Array.from(e.target.files || []), props.isBasic, folderId);
    };
    const handleUploadFolder = async (e) => {
        e.preventDefault();
        const folderName = e.target.files?.[0]?.webkitRelativePath?.split('/')[0];
        if (folderName) {
            props.createFolder(props.currentFolder.id, folderName, (folderId) => props.uploadFiles(Array.from(e.target.files || []), props.isBasic, folderId));
        }
    };
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const [contextItem, setContextItem] = useState(null);
    const handleMenuItemClick = () => {
        setContextMenuVisible(false);
    };
    const handleContextMenu = (e, item) => {
        e.preventDefault();
        if (item.folderType === 'camera_uploads')
            return;
        setContextMenuVisible(true);
        setContextMenuPosition({ x: e.pageX + 10, y: e.pageY });
        setContextItem(item);
    };
    const handleEmptyClick = () => {
        setHighlighted(null);
        setContextMenuVisible(false);
    };
    const { currentFolder } = props;
    return (React.createElement("div", { className: s.main, id: 'main', onClick: handleEmptyClick, role: 'button', tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ')
                handleEmptyClick();
        } },
        contextMenuVisible && (React.createElement(ContextMenu, { x: contextMenuPosition.x, y: contextMenuPosition.y, onItemClick: handleMenuItemClick, item: contextItem, type: 'file' })),
        React.createElement(InputModal, { visible: modalVisible, setVisible: setModalVisible, title: 'New Folder', doneText: 'Create', onChange: (e) => setFolderName(e.target.value), done: () => {
                props.createFolder(props.currentFolder.id, folderName);
                setModalVisible(false);
            } }),
        React.createElement(UploadMenu, null),
        React.createElement(FileView, null),
        React.createElement(MovingFileView, null),
        React.createElement("div", { className: s.screenContainer },
            React.createElement("div", { className: s.stackContainer }, props.folderStack.map((item, index) => {
                const color = currentFolder.name === item.name ? gs.blackColor : gs.greyColor;
                return (React.createElement("div", { className: s.stackItem, key: item.id },
                    React.createElement("button", { type: 'button', onClick: () => {
                            if (!props.fetchedFolders[item.id])
                                props.fetchFiles({ folderId: item.id, firstFetch: false, refresh: true });
                            props.setFolder(item.id);
                        }, className: `${s.stackItemTitle} ${color}` },
                        props.isSearching && React.createElement(RiArrowLeftSLine, { fontSize: 20, className: gs.greyColor }),
                        item.name === 'home' ? 'Vault' : item.name),
                    index < props.folderStack.length - 1 && (React.createElement("span", { style: { marginLeft: '10px', marginRight: '10px' } },
                        React.createElement(RiArrowRightSLine, { fontSize: 20, className: gs.greyColor })))));
            })),
            props.isSearching && React.createElement("p", { className: s.resultsTitle }, "Search results"),
            React.createElement("div", { style: { flexDirection: 'row', display: 'flex' } },
                React.createElement(ActionButton, { htmlFor: 'upload', text: 'Upload files', icon: React.createElement(TbFileUpload, { fontSize: 20 }) }),
                React.createElement(ActionButton, { htmlFor: 'upload-folder', text: 'Upload folder', icon: React.createElement(MdOutlineDriveFolderUpload, { fontSize: 20 }), style: { marginLeft: 12 } }),
                React.createElement(ActionButton, { onClick: () => setModalVisible(true), text: 'Create folder', icon: React.createElement(AiOutlineFolderAdd, { fontSize: 20 }), style: { marginLeft: 12 } }),
                React.createElement(ActionButton, { onClick: () => history.push('/vault/notes/create-note'), text: 'New note', icon: React.createElement(CiStickyNote, { fontSize: 20 }), style: { marginLeft: 12 } })),
            React.createElement("input", { type: 'file', multiple: true, id: 'upload', style: { display: 'none' }, onChange: handleUploadFiles }),
            React.createElement("input", { type: 'file', 
                // @ts-ignore
                // eslint-disable-next-line react/no-unknown-property
                directory: '', webkitdirectory: '', 
                // @ts-ignore
                // eslint-disable-next-line react/no-unknown-property
                moxdirectory: '', multiple: true, id: 'upload-folder', style: { display: 'none' }, onChange: handleUploadFolder }),
            props.files.length > 0 ? (props.files.map((section) => (React.createElement("div", { style: { marginTop: '2vh' }, key: section.title },
                React.createElement(SectionTitle, { section: section }),
                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap' } }, section.data.map((item, index) => (React.createElement(Folder, { item: item, index: index, key: `${item.name}${index}`, highlighted: highlighted, setHighlighted: (id) => setHighlighted(id), handleContextMenu: (e) => handleContextMenu(e, item) })))))))) : props.fetched ? (React.createElement("p", { className: s.emptyText }, "This folder is empty")) : (React.createElement("p", { className: s.emptyText }, props.isSearching && props.emptySearch ? 'No results found' : 'Loading...')))));
};
const mapStateToProps = (state) => {
    const isSearching = state.appTemp.isSearching;
    const currentFolder = isSearching
        ? { id: 'search', name: '' }
        : state.appTemp.folderStack[state.appTemp.folderStack.length - 1];
    let lastFolderName = state.appTemp.folderStack.length === 1
        ? 'home'
        : state.appTemp.folderStack[state.appTemp.folderStack.length - 2].name;
    if (lastFolderName === 'home')
        lastFolderName = 'Vault';
    const mostRecent = currentFolder.id === 'home' ? state.filesTree.mostRecent : null;
    return {
        isSearching,
        emptySearch: state.appTemp.emptySearch,
        files: createFileSections(state.filesTree[currentFolder.id] || [], mostRecent, state.files),
        fetched: state.fetched.folders[currentFolder.id],
        fetchedFolders: state.fetched.folders,
        currentFolder,
        lastFolderName,
        folderStack: state.appTemp.folderStack,
        downloadProgress: state.download,
        url: state.url.filesUrls[currentFolder.id],
        searchUrl: state.url.searchUrl,
        fileViewVisible: state.appTemp.fileView.visible,
        isBasic: !state.auth.user || state.auth.user.subscription === 'basic',
        user: state.auth.user,
        isAuthenticated: state.auth.isAuthenticated,
    };
};
const connector = connect(mapStateToProps, { ...vault, ...auth });
export default connector(VaultScreen);
